import { render } from "./AdminGallery.vue?vue&type=template&id=10547281&scoped=true"
import script from "./AdminGallery.vue?vue&type=script&lang=js"
export * from "./AdminGallery.vue?vue&type=script&lang=js"

import "./AdminGallery.vue?vue&type=style&index=0&id=10547281&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10547281"]])

export default __exports__